module.exports = "<div class=\"row\">\r\n  <div class=\"col\">\r\n    <div class=\"container\">\r\n      <ul class=\"progressbar\">\r\n        <li class=\"{{step1Class}}\">Register</li>\r\n        <li class=\"{{step2Class}}\">Choose Location</li>\r\n        <li class=\"{{step3Class}}\">Pay/Confirm</li>  \r\n      </ul>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!--repeat this block of code in all steps and add \"active\" class to list items-->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/register-progress/register-progress.component.html
// module id = ./src/app/register-progress/register-progress.component.html
// module chunks = main